// extracted by mini-css-extract-plugin
export var opiContainer = "bV_hV";
export var opiContainerCell = "bV_hY";
export var opiContainerColumn = "bV_hX";
export var opiContainerInner = "bV_hW";
export var opiET = "bV_h4";
export var opiETContainer = "bV_h2";
export var opiETContent = "bV_h6";
export var opiETImg = "bV_h5";
export var opiSection1 = "bV_h0";
export var opiSection2 = "bV_h1";
export var opiWysj = "bV_hZ";
export var opiWysjReasons = "bV_h3";